import React, { useState } from "react";
import { FiGlobe } from "react-icons/fi";

interface LanguageSwitcherProps {
  onChange: (language: string) => void;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const languages = [
    { code: "en", name: "English" },
    { code: "fi", name: "Finnish" },
    { code: "tr", name: "Turkish" },
  ];

  const handleLanguageChange = (languageCode: string) => {
    setSelectedLanguage(languageCode);
    setIsOpen(false);
    onChange(languageCode);
  };

  return (
    <div className="relative">
      <button
        className="flex items-center space-x-2 bg-white rounded-full py-2 px-3 border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors text-sm"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FiGlobe className="text-orange-500" />
        <span className="font-medium">
          {languages.find((lang) => lang.code === selectedLanguage)?.name}
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className={`block w-full text-left px-4 py-2 text-sm ${
                selectedLanguage === language.code
                  ? "bg-orange-50 text-orange-500 font-medium"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              {language.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
